import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {EnvironmentService} from '@iw-shop/core//services/environment.service';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class AppInitConfigService {

    private httpWithoutInterceptor: HttpClient;

    private readonly isBrowser: boolean;

    constructor(
        private handler: HttpBackend,
        private environmentService: EnvironmentService,
    @Inject(PLATFORM_ID) platformId: Object
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.httpWithoutInterceptor = new HttpClient(this.handler);
    }

    async init() {
        let configUrl: string;
        if (this.isBrowser) {
            configUrl = './assets/configs/browser-20250505.json';
        } else {
            configUrl = 'http://127.0.0.1/drinks/shops/_basic/src/assets/configs/undefined.json';

            if (process.env['urlApi'] &&
                process.env['urlS3']) {
                this.environmentService.setEnvironment({
                    urlApi:  process.env['urlApi'],
                    urlS3: process.env['urlS3']
                });
                //console.log(configUrl, 'set environment');
                return Promise.resolve();
            }
            //console.log(configUrl, 'configUrl 2');
            //configUrl = 'http://localhost/assets/configs/' + this.ssrReq.headers.myconfig + '.json';
        }
        return new Promise<void>((resolve, reject) => {

            this.httpWithoutInterceptor.get(configUrl).subscribe(
                {
                    next: (res: any) => {
                        this.environmentService.setEnvironment(res);
                        resolve();

                    },
                    error: (err) => {
                        reject(err);
                    },
                    complete: () => {
                        resolve();
                    }
                }
            )
        });
    }
}
